// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"2deded8a","239":"e1d138e2","382":"eb0798fe","453":"87dff8ca","455":"e9377ea3","568":"ce154259","977":"e13122b6"}[chunkId] + ".chunk.js";
};